import { useLingui } from "@lingui/react";
import type { CaravanAd } from "@mobility-item-page/types";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "../../../../context/AppConfigProviderContext.tsx";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "./../types.ts";

export const InteriorLength = ({ length }: SpecProps<"length", CaravanAd>) => {
  const { locale } = useAppConfig();
  const { i18n } = useLingui();

  if (length?.interior == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.interiorLength",
    message: "Inside length",
    comment: "Field for 'inside length' in ad specification",
  });

  const value = i18n.t({
    id: "itemPageLayout.common.length.value",
    message: "{length} cm",
    comment: "Length incl. postfix in cm",
    values: { length: formatNumber(length.interior, locale) },
  });

  return <FieldValuePair field={field} value={value} />;
};
